import React from "react";
import {
  createStyles,
  Box,
  Stack,
  Text,
  Center,
  Image,
  Space,
  Group,
  Anchor,
} from "@mantine/core";

import { Link, useNavigate } from "react-router-dom";

function TermsPage({ children, ...otherProps }) {
  const { classes } = useStyles();
  const navigation = useNavigate();
  return (
    <Box className={classes.container} {...otherProps}>
      <Box className={classes.root}>
        <Box className={classes.grid}>
          <Box className={classes.section}>
            <Center px={50} pt={30} pb={10}>
              <Stack spacing={0} justify='center'>
                <Center>
                  <Group spacing={10} align="center" sx={{ cursor: "pointer" }} onClick={() => navigation("/")}>
                    <Box
                      sx={{
                        width: 44,
                        height: 44,
                        borderRadius: "50%",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "linear-gradient(135deg, #B049C5, #6A59D8)",
                      }}
                    >
                      <Image
                        src="/flipwave-ico.svg"
                        alt="FlipWave"
                        width={30}
                        height={30}
                        sx={{ objectFit: "contain" }}
                      />
                    </Box>
                    <Text weight={800} size={30} sx={{ color: "#7749FD" }}>
                      FlipWave
                    </Text>
                  </Group>
                </Center>
              </Stack>
            </Center>
          </Box>
          <Space h={30} />
        </Box>
      </Box>

      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid}>
            <Box className={classes.section} mt={50}>
              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Terms of Service
                </Text>
                <Text weight={400} size={18} fs='italic'>
                  Last Updated: April 4, 2026
                </Text>
                <Text weight={400} size={18}>
                  These terms of service ("Terms") apply to your access and use of
                  "FlipWave" iOS app. Please read them carefully.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Application License Agreement
                </Text>
                <Text weight={400} size={18} mt={10}>
                  Your access to and use of the proprietary software application known as
                  "FlipWave" ("Software") is conditioned on your acceptance of and
                  compliance with these Terms. These Terms apply to all visitors, users
                  and others who access or use the Software. By accessing or using the
                  Software you agree to be bound by these Terms. If you disagree with any
                  part of the terms then you may not access the Software. So, before you
                  use the Service, please read all of the terms. If you don't agree to all
                  of the terms below, please do not use the Service. We reserve the right
                  to modify these Terms at any time. For instance, we may need to change
                  these Terms if we come out with a new feature or for some other reason.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Privacy Policy
                </Text>
                <Text weight={400} size={18}>
                  For information about how we collect and use information about users of
                  the Service, please check out our privacy policy available at:{" "}
                  <Anchor to='/privacy' component={Link} sx={{ color: "#7749FD" }}>
                    https://flipaudio.app/privacy
                  </Anchor>
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Grant of License
                </Text>
                <Text weight={400} size={18} mt={10}>
                  Subject to your compliance with the terms and conditions set forth
                  herein, "FlipWave" hereby grants you a limited, non-exclusive,
                  non-transferable, non-sublicensable license to install and use one copy
                  of the Software on your mobile device for the sole purpose of accessing,
                  opening and using the capabilities and services enabled via the
                  Software. Restrictions on Use. You may not: (i) copy, modify, translate,
                  reverse engineer, decompile or disassemble the Software or create
                  derivative works based thereon; (ii) install the Software onto a server
                  so that it is accessible via a public network; (iii) share or permit
                  other individuals/entities to use the Software, rent, lease or transfer
                  the Software or rights to use it; or (iv) delete or modify any
                  attributions, legal notices or other proprietary designations in the
                  Software or part thereof. Any such forbidden use shall immediately and
                  automatically terminate your license to use the Software, without
                  derogating from any other remedies available to "FlipWave" at law or in
                  equity.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Title and Ownership
                </Text>
                <Text weight={400} size={18} mt={10}>
                  The Software and any revisions, modifications, enhancements and/or
                  derivatives thereof are owned by "FlipWave" and/or its licensors and are
                  protected under copyright laws and treaties. All right, title, and
                  interest in and to the Software, including all associated intellectual
                  property rights are and shall remain owned solely by "FlipWave" and/or
                  its licensors.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Third Party Software
                </Text>
                <Text weight={400} size={18} mt={10}>
                  Any third party software that may be provided with the Software is
                  included for use at your option. Such third party software is provided
                  under the terms of the license attached/linked thereto or, if no such
                  license is attached, such third party software is provided AS IS.
                  "FlipWave" is not liable for any losses or damages which may occur from
                  the use of any third party software.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Updates/Upgrades
                </Text>
                <Text weight={400} size={18} mt={10}>
                  "FlipWave" improves from time to time the Software and may
                  update/upgrade the Software at its sole discretion, with or without
                  notification. At "FlipWave"'s sole discretion, "FlipWave" may notify you
                  through a patch process, or by email, or website posting of such updates
                  or upgrades available for download. Some updates/upgrades may be
                  optional and some may be mandatory in order to operate the Software. At
                  its sole discretion, "FlipWave" may, but is not obligated to, provide
                  email and/or internet based support with online help.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Paid accounts
                </Text>
                <Text weight={400} size={18} mt={10}>
                  "FlipWave" is a subscription based digital service. "FlipWave" reserves
                  the right to change the products' price at any time. "FlipWave" reserves
                  the right to refuse or cancel certain orders at our sole discretion.
                  "FlipWave" might offer contests, discounts or promotions on the website.
                  "FlipWave" reserves the right to update subscription plans benefits at
                  any time. "FlipWave" Premium entitles you with full access to
                  "FlipWave"'s premium features on all platforms. If you upgrade from the
                  free version to any paid plan, we will immediately bill you for the
                  applicable subscription fees. "FlipWave" will automatically renew your
                  subscription for the same plan length unless you cancel your
                  subscription at least 48 hours before the end of the current period. An
                  email or phone request to cancel your subscription is not considered
                  cancellation. Any cancellation will take effect only at the end of your
                  then current contract period. "FlipWave" holds a NO REFUND POLICY.
                  "FlipWave" is free to try for an unlimited amount of time and thus
                  subscriptions to the service are non-refundable. All sales are final.
                  "FlipWave" reserves the right to offer refunds in select circumstances
                  at its sole discretion. "FlipWave" reserves the right to terminate
                  access to certain users in case of abuse or misuse of the platform.
                  "FlipWave" exclusively owns the content and the trademarks displayed on
                  the app.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Compliance with Law
                </Text>
                <Text weight={400} size={18} mt={10}>
                  This Software is intended for use only in compliance with applicable
                  laws and only with properly licensed media and content. You undertake to
                  use the Software in accordance with all applicable laws, including
                  without limitation, all applicable export laws, restrictions and
                  regulations and agree that you will not export, or allow the export or
                  re-export of the Software in violation of any such laws, restrictions
                  and/or regulations. You agree to the foregoing and represent and warrant
                  that you are not located in, under the control of, or a national or
                  resident of any restricted country.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Changes to Software or License Agreement
                </Text>
                <Text weight={400} size={18} mt={10}>
                  "FlipWave" may modify, suspend, or discontinue any aspect of the
                  Software at any time. "FlipWave" reserves the right to modify the terms
                  of this License Agreement, whereby material changes will be disclosed to
                  you through a patch process or through website posting. Except for
                  changes to this License Agreement that affect your privacy, which shall
                  be subject to your specific acceptance, your continued use of the
                  Software, following any revision of the Software or this License
                  Agreement, constitutes your acceptance of any such changes.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Unavoidable Legal Stuff
                </Text>
                <Text weight={400} size={18} mt={10} sx={{ textTransform: "uppercase" }}>
                  THE SERVICE AND ANY OTHER SERVICE AND CONTENT INCLUDED ON OR OTHERWISE
                  MADE AVAILABLE TO YOU THROUGH THE SERVICE ARE PROVIDED TO YOU ON AN AS
                  IS OR AS AVAILABLE BASIS WITHOUT ANY REPRESENTATIONS OR WARRANTIES OF
                  ANY KIND. WE DISCLAIM ANY AND ALL WARRANTIES AND REPRESENTATIONS
                  (EXPRESS OR IMPLIED, ORAL OR WRITTEN) WITH RESPECT TO THE SERVICE AND
                  CONTENT INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE
                  SERVICE WHETHER ALLEGED TO ARISE BY OPERATION OF LAW, BY REASON OF
                  CUSTOM OR USAGE IN THE TRADE, BY COURSE OF DEALING OR OTHERWISE.
                </Text>
                <Text weight={400} size={18} mt={10} sx={{ textTransform: "uppercase" }}>
                  IN NO EVENT WILL "ANATOLI NICULEAC" BE LIABLE TO YOU OR ANY THIRD PARTY
                  FOR ANY SPECIAL, INDIRECT, INCIDENTAL, EXEMPLARY OR CONSEQUENTIAL
                  DAMAGES OF ANY KIND ARISING OUT OF OR IN CONNECTION WITH THE SERVICE OR
                  ANY OTHER SERVICE AND/OR CONTENT INCLUDED ON OR OTHERWISE MADE AVAILABLE
                  TO YOU THROUGH THE SERVICE, REGARDLESS OF THE FORM OF ACTION, WHETHER IN
                  CONTRACT, TORT, STRICT LIABILITY OR OTHERWISE, EVEN IF WE HAVE BEEN
                  ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR ARE AWARE OF THE
                  POSSIBILITY OF SUCH DAMAGES. OUR TOTAL LIABILITY FOR ALL CAUSES OF
                  ACTION AND UNDER ALL THEORIES OF LIABILITY WILL BE LIMITED TO THE AMOUNT
                  YOU PAID TO "ANATOLI NICULEAC". THIS SECTION WILL BE GIVEN FULL EFFECT
                  EVEN IF ANY REMEDY SPECIFIED IN THIS AGREEMENT IS DEEMED TO HAVE FAILED
                  OF ITS ESSENTIAL PURPOSE.
                </Text>
                <Text weight={400} size={18} mt={10}>
                  You agree to defend, indemnify and hold us harmless from and against any
                  and all costs, damages, liabilities, and expenses (including attorneys'
                  fees, costs, penalties, interest and disbursements) we incur in relation
                  to, arising from, or for the purpose of avoiding, any claim or demand
                  from a third party relating to your use of the Service or the use of the
                  Service by any person using your account, including any claim that your
                  use of the Service violates any applicable law or regulation, or the
                  rights of any third party, and/or your violation of these Terms.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Immediate Termination
                </Text>
                <Text weight={400} size={18} mt={10}>
                  Without prejudice to any other rights, this Agreement and your right to
                  use this Software automatically terminates if you fail to comply with
                  any provision of this License Agreement. "FlipWave" may terminate this
                  License Agreement at any time with or without prior notice. You may
                  terminate this license at any time by stopping your use thereof and
                  un-installing the Software.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Data Sharing with Apple
                </Text>
                <Text weight={400} size={18} mt={10}>
                  By using this app, you agree that certain personal data may be shared
                  with Apple to assist with reviewing refund requests. This data sharing
                  is limited to the purposes of facilitating refund reviews and is
                  conducted in compliance with applicable laws. By continuing to use the
                  app, you acknowledge and consent to this data-sharing practice as
                  outlined in our Terms of Use.
                </Text>
              </Stack>

              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  How to Contact Us
                </Text>
                <Text weight={400} size={18} mt={10}>
                  If you have any questions about these Terms, please contact us by email
                  at <Anchor href='mailto:terms@flipaudio.app' sx={{ color: "#7749FD" }}>terms@flipaudio.app</Anchor>{" "}
                  or contact form as follows{" "}
                  <Anchor component={Link} to='/contact' sx={{ color: "#7749FD" }}>
                    Contact Us
                  </Anchor>
                </Text>
              </Stack>
            </Box>
            <Space h={30} />
          </Box>
        </Box>
      </Box>

      {/* Footer */}
      <Box className={classes.containerFooter}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Text weight={400} size={16} align='left' sx={{ color: "#87808A" }}>
                Made with love by Anatoli Niculeac<sup>&copy;</sup> 2026
              </Text>
              <Group spacing={10} p={20} position='right'>
                <Anchor component={Link} to={"/support"} className={classes.link}>
                  <Text weight={500} size={16} align='left' sx={{ color: "#7749FD" }}>
                    Support
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "#87808A" }}>
                  |
                </Text>
                <Anchor component={Link} to={"/terms"} className={classes.link}>
                  <Text weight={500} size={16} align='left' sx={{ color: "#7749FD" }}>
                    Terms of use
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "#87808A" }}>
                  |
                </Text>
                <Anchor component={Link} to={"/privacy"} className={classes.link}>
                  <Text weight={500} size={16} align='left' sx={{ color: "#7749FD" }}>
                    Privacy Policy
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "#87808A" }}>
                  |
                </Text>
                <Anchor component={Link} to={"/contact"} className={classes.link}>
                  <Text weight={500} size={16} align='left' sx={{ color: "#7749FD" }}>
                    Contact
                  </Text>
                </Anchor>
              </Group>
              <Space h={10} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default TermsPage;

const useStyles = createStyles({
  root: {
    height: "100%",
    width: "100%",
    overflowX: "hidden",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  container: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",
    "@media (max-width: 768px)": { width: "100%" },
    width: "100%",
    height: "100%",
    background: "linear-gradient(180deg, #FBE1F6 0%, #FCE9F9 100%)",
  },
  containerTwo: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",
    "@media (max-width: 768px)": { width: "100%" },
    width: "100%",
    height: "100%",
    backgroundColor: "#FFFFFF",
  },
  containerFooter: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",
    "@media (max-width: 768px)": { width: "100%" },
    width: "100%",
    height: "100%",
    background: "linear-gradient(180deg, #FCE9F9 0%, #FBE1F6 100%)",
  },
  section: {
    maxWidth: 980,
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: 25,
    alignItems: "center",
    paddingLeft: 25,
    paddingRight: 25,
  },
  sectionTwo: {
    maxWidth: 980,
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: "1em",
    alignItems: "center",
    paddingLeft: 25,
    paddingRight: 25,
  },
  grid: {
    display: "grid",
    width: "100%",
    height: "100%",
    gridTemplateColumns: "auto",
    gridTemplateRows: "auto",
    "@media (max-width: 1023px)": {
      gridTemplateColumns: "auto",
      justifyContent: "stretch",
    },
    "@media (min-width: 1600px)": {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto",
      WebkitTransition: "300ms",
    },
  },
  link: {
    whiteSpace: "nowrap",
    textDecoration: "none",
    ":last-child": { borderRight: "none" },
    transition: "opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)",
    ":hover": {
      textDecoration: "none",
      opacity: 0.7,
    },
  },
});
